<div class="inner-content">
  <p class="title">{{ "SELECT_COUNTRY" | translate }}</p>
  <div class="countries">
    <div tappable class="country" *ngFor="let country of availableCountries" (click)="onCountryChange(country)">
      <div class="country-flag" [style.backgroundImage]="'url(' + country.flagUrl + ')'"></div>
      <div class="country-name">{{ country.name | translate }}</div>
    </div>
  </div>
</div>
